<template>
    <div v-if="validateBtn" class="new-quotation-btn right">
        <a @click="goToNewCompetition" class="btn btn-center">
            <i class="material-icons left fas fa-plus-circle"></i>
            <span>Nova cotação</span>
        </a>
    </div>
    <div v-else></div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'eg-new-competition',
    methods: {
        goToNewCompetition() {
            const routeData = this.$router.resolve({name: 'StructuredQuote'});
            window.open(routeData.href, '_blank');
        }
    },
    computed: {
        ...mapState('user', ['user']),
        validateBtn() {
            if (this.user.type && this.user.type.isRequester) {
                return false;
            } else {
                return true;
            }
        }
    }
};
</script>

<style lang="scss">
/* Btn de nova cotação */
.new-quotation-btn a span {
    font-size: 1.1rem;
    line-height: inherit;
}

.new-quotation-btn a .material-icons {
    margin-right: 4px;
    height: 100%;
}

.new-quotation-btn a {
    display: flex;
    flex-direction: row;
    justify-content: center;
    justify-items: center;

    background-color: #007bff;
    text-transform: none;
    font-size: 16px;
    font-weight: bold;
}

.new-quotation-btn a:hover {
    background-color: #007bff;
}
@media screen and (max-width: 768px) {
    .new-quotation-btn.right {
        float: none !important;
        position: relative !important;
        top: 4px !important;
        margin-right: 8px !important;
        padding-top: 8px;
        padding-bottom: 8px;
    }
    .new-quotation-btn .btn {
        width: 100%;
    }
}
</style>
